module.exports = __webpack_public_path__ + "img/officePic4s.ca550cf4.jpg";